import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesStock from "Dashboard/scenes/Stock/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import {
  selectState,
  selectStockInputForUpdateItem,
  setUpdateInputItemPopover,
  updateStockInput
} from "../inputSlice";
import { IStockInputUpdate } from "Dashboard/scenes/Stock/domain/IStockInputUpdate";
import NumberInput from "Dashboard/components/NumberInput";
import StockItemSelectCreate from "./StockItemSelectCreate";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo } from "utils/authUtil";
import { STOCK_MODULE_NAME } from "Dashboard/scenes/Stock/domain/StockModule";

const UpdateStockInputItemPopover = () => {
  const dispatch = useAppDispatch();
  const stockInput = useSelector(selectStockInputForUpdateItem);
  const { updateInputItemPopover } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
    getValues,
  } = useForm<IStockInputUpdate>();

  const closeDialog = () => {
    dispatch(setUpdateInputItemPopover({ isOpen: false, itemRowIndex: -1 }));
    reset();
  };

  const onSubmit = async (data: IStockInputUpdate) => {
    try {
      await dispatch(updateStockInput(data));
      closeDialog();
      toast.success("Izmena je uspešno zabeležena.");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`
        ${classes.basicPopoverView} 
        ${classes.gPopoverInputs}
        ${classesStock.updateInputItemPopover}
      `}
    >
      <p>Ovde menjate šifru, ime i cenu artikla na ulazu kao i na svim zapisima izlaza ovog artikla.</p>
      <input
        type="hidden"
        value={stockInput?.inputId}
        {...register("inputId")}
      />

      <div className={`${errors.itemCode ? classes.inputError : ""}`}>
        <div>
          <label>nova šifra</label>
          <input
            type="text" className={classes.solidBorder}
            autoFocus={updateInputItemPopover.focus === "itemCode"}
            defaultValue={stockInput !== null ? stockInput.itemCode : ""}
            {...register("itemCode", { required: false })} />
        </div>
      </div>
      <div>
        <div>
          <label>nova cena</label>
          <Controller
            control={control}
            name="pricePerUnit"
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <NumberInput
                  formatAs="rsd"
                  autoFocus={updateInputItemPopover.focus === "pricePerUnit"}
                  onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                  defaultValue={stockInput?.pricePerUnit !== null && stockInput?.pricePerUnit !== undefined ? stockInput.pricePerUnit.toString().replace(".", ",") : ""}
                  className={`${classes.solidBorder} ${errors.pricePerUnit ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>
      <div>zamena artikla promeniće artikal samo za ovaj unos</div>
      <div>i na svim izlazima ovog unosa u lageru</div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.itemId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>zameni artikal</label>
          <Controller
            name="itemId"
            control={control}
            defaultValue={stockInput !== null ? stockInput.item.itemId : undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <StockItemSelectCreate
                value={getValues("itemId") || stockInput?.item.itemId}
                error={errors.itemId}
                menuPortalTarget={document.body}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
                preserveInput={false}
                menuPosition="fixed"
              />
            )}
          />
        </div>
      </div>
      {hasFullAccessTo(user, STOCK_MODULE_NAME) && (
        <>
          <div>promena naziva artikla promeniće naziv ovog artikla</div>
          <div>na svim ulazima i izlazima ovog artikla u lageru</div>
          <div className={`${errors.itemName ? classes.inputError : ""}`}>
            <div>
              <label>promeni naziv artikla</label>
              <input
                type="text" className={classes.solidBorder}
                autoFocus={updateInputItemPopover.focus === "itemName"}
                defaultValue={stockInput !== null ? stockInput.item.name : ""}
                {...register("itemName", { required: true })} />
            </div>
          </div>
        </>
      )}

      <div className={classes.buttons}>
        <button type="submit" className={classes.iconButton}>
          <FontAwesomeIcon
            icon={faLongArrowAltDown}
            className={classes.icon} />
        </button>
      </div>
    </form>
  )
};

export default UpdateStockInputItemPopover;
